import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import Tutoriales from 'sites/admin/inmobiliario/ayuda/Tutoriales';

const RoutesAyuda = () => {
  const token = localStorage.getItem('token_A');

  return (
    <Route path="/ayuda">
      <Route
        path="tutoriales"
        element={
          token === null ? <Navigate to={'/ingresar'} /> : <Tutoriales />
        }
      />
    </Route>
  );
};

export default RoutesAyuda;
